import { useAuth } from 'grabbitbot-legacy-ui'

/** Legacy `UserComponent` — a minimal, read-only profile (`GET /user/current`). */
export function UserPage() {
  const { user } = useAuth()
  if (!user) return null

  return (
    <div className="wnf-card wnf-card--profile">
      <h1>Your account</h1>
      <dl>
        <dt>Email</dt>
        <dd>{user.username}</dd>
        {user.roles && user.roles.length > 0 && (
          <>
            <dt>Roles</dt>
            <dd>{user.roles.join(', ')}</dd>
          </>
        )}
      </dl>
    </div>
  )
}
